import HorizontalContainerWithFadedOverflow from 'components/Common/HorizontalContainerWithFadedOverflow'
import FilterChip from 'components/Luxkit/Chips/FilterChip'
import Group from 'components/utils/Group'
import React from 'react'
import { MAX_FILTER_COUNT } from './constants'
import { take } from 'lib/array/arrayUtils'
import { HolidayTypeToIconMap } from 'lib/search/searchUtils'
import { getValueByCaseInsensitiveKey } from 'lib/objectUtils'

interface Props {
  options: string[]
  active?: string;
  onClick?: (option: string) => void;
}

function OfferCarouselFilters({
  options,
  active,
  onClick,
}: Props) {
  if (options.length === 0) {
    return null
  }

  return (
    <HorizontalContainerWithFadedOverflow>
      <Group direction="horizontal" gap={8}>
        {take(options, MAX_FILTER_COUNT).map(option => {
          const icon = getValueByCaseInsensitiveKey(
            HolidayTypeToIconMap,
            option,
          )

          return (
            <FilterChip
              key={option}
              size="medium"
              selected={option === active}
              onClick={() => onClick ? onClick(option) : undefined}
              startIcon={icon}
            >
              {option}
            </FilterChip>
          ) })}
      </Group>
    </HorizontalContainerWithFadedOverflow>
  )
}

export default OfferCarouselFilters
